module.exports = __webpack_public_path__ + "static/media/img35.79c02119.jpg";